<template>
  <el-dialog
    :visible.sync="dialogVisible"
    class="bind-phone-dialog"
    width="600px"
    title="绑定手机号"
    append-to-body
    @closed="onClosed"
  >
    <div class="dialog-content">
      <div class="send-box">
        <div class="title">手机号</div>
        <el-input
          type="input"
          v-model="phoneNumber"
          placeholder="请输入手机号"
        ></el-input>
      </div>
      <div class="send-wrap">
        <div class="title">验证码</div>
        <el-input
          type="input"
          v-model="authCode"
          placeholder="请输入验证码"
        ></el-input>
        <el-button
          type="warning"
          @click="getPhone"
          :disabled="isDisabled"
          :class="{ 'btn-forbid': isDisabled }"
          >{{ codeTxt }}</el-button
        >
      </div>
      <div class="bottom-wrap">
        <el-button @click="confirm" type="warning" :loading="submitting"
          >确定</el-button
        >
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { getVercode } from '@/api/common';
import { changePhone } from '@/api/account';
import { mapState } from 'vuex';

export default {
  name: 'BindPhoneDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      phoneNumber: '',
      authCode: '',
      isDisabled: false,
      codeTxt: '获取验证码',
      submitting: false,
      timer: null,
    };
  },
  computed: {
    ...mapState(['userInfo']),
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
  },
  methods: {
    getPhone() {
      if (!this.phoneNumber) {
        this.$message.error('手机号不能为空');
        return;
      }
      // 简单的手机号校验
      if (!/^1[3-9]\d{9}$/.test(this.phoneNumber)) {
        this.$message.error('请输入正确的手机号');
        return;
      }
      this.fetchGetVercode();
    },
    async fetchGetVercode() {
      try {
        await getVercode({ phone: this.phoneNumber, op: 1 });
        this.$message.success('发送成功');
        this.countDown();
      } catch (error) {
        console.error(error);
      }
    },
    countDown() {
      let time = 60;
      this.isDisabled = true;
      this.codeTxt = `重新发送${time}S`;
      this.timer = setInterval(() => {
        time--;
        if (time > 0) {
          this.codeTxt = `重新发送${time}S`;
        } else {
          this.clearTimer();
        }
      }, 1000);
    },
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      this.isDisabled = false;
      this.codeTxt = '获取验证码';
    },
    async confirm() {
      if (!this.phoneNumber) {
        this.$message.error('手机号不能为空');
        return;
      }
      if (!this.authCode) {
        this.$message.error('验证码不能为空');
        return;
      }
      this.submitting = true;
      try {
        await changePhone({
          vercode: this.authCode,
          new_phone: this.phoneNumber,
          tk: this.userInfo.tk,
          op: 1,
        });
        this.$message.success('绑定成功');
        this.$emit('success');
        this.dialogVisible = false;
      } catch (error) {
        console.error(error);
      } finally {
        this.submitting = false;
      }
    },
    onClosed() {
      this.phoneNumber = '';
      this.authCode = '';
      this.clearTimer();
    },
  },
  beforeDestroy() {
    this.clearTimer();
  },
};
</script>

<style lang="scss" scoped>
.bind-phone-dialog {
  ::v-deep.el-dialog__header {
    padding: 0;
    padding-top: 40px;
    text-align: center;
    .el-dialog__title {
      font-size: 20px;
    }
  }
  .dialog-content {
    .send-box {
      display: flex;
      margin-bottom: 40px;
      margin-left: 30px;
      font-size: 16px;
      .title {
        width: 110px;
        padding-top: 10px;
      }
      ::v-deep.el-input__inner {
        width: 360px !important;
      }
    }
    .send-wrap {
      margin-bottom: 20px;
      display: flex;
      margin-left: 30px;
      font-size: 16px;
      .title {
        width: 90px;
        padding-top: 10px;
      }
      ::v-deep.el-input {
        width: 240px;
      }
      ::v-deep.el-input__inner {
        width: 220px !important;
      }
      .el-button {
        height: 40px;
        border-radius: 8px;
        width: 120px;
      }
      .el-button.el-button--warning.btn-forbid {
        cursor: not-allowed;
        background: #d9d9d9 !important;
        border: none;
        &:hover {
          filter: brightness(100%);
        }
      }
    }
    .bottom-wrap {
      text-align: center;
      margin-top: 50px;
      margin-bottom: 20px;
      .el-button {
        width: 120px;
      }
    }
  }
}
</style>
